import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/index.vue";
import store from "../store";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: HomeView
    // },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    },
    {
        path: "/product",
        name: "product",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "product" */ "../views/product.vue"),
        meta: {
            Chinese: "产品展示",
            English: "Products Show",
        },
    },
    {
        path: "/dynamics",
        name: "dynamics",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "dynamics" */ "../views/dynamics.vue"),
        meta: {
            Chinese: "赛事动态",
            English: "Events",
        },
    },
    {
        path: "/",
        name: "introduction",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "introduction" */ "../views/introduction.vue"
            ),
        meta: {
            Chinese: "大赛简介",
            English: "About",

            //  "中国自行车产业大会"
            // China Bicycle Industry Conferencer
        },
    },
    {
        path: "/download",
        name: "download",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "download" */ "../views/download.vue"),
        meta: {
            Chinese: "资料下载",
            English: "Material",
        },
    },
    {
        path: "/user",
        name: "user",
        component: () =>
            import(/* webpackChunkName: "download" */ "../views/user.vue"),
        meta: {
            Chinese: "个人中心",
            English: "Personal",
        },
    },
    // 修改密码1
    {
        path: "/changePassword",
        name: "changePassword",
        component: () =>
            import(
                /* webpackChunkName: "download" */ "../views/changePassword.vue"
            ),
    },
    {
        path: "/forum",
        name: "forum",
        component: () =>
            import(
                /* webpackChunkName: "download" */ "../views/forum/forum.vue"
            ),
        meta: {
            Chinese: "电动车高峰论坛",
        },
    },

    {
        path: "/newsnotice",
        name: "newsnotice",
        component: () =>
            import(
                /* webpackChunkName: "head" */ "../views/forum/Newsnotice.vue"
            ),
        meta: {
            Chinese: "新闻通稿",
        },
    },
    {
        path: "/generalassembly",
        name: "generalassembly",
        component: () =>
            import(
                /* webpackChunkName: "head" */ "../views/forum/Generalassembly.vue"
            ),
        meta: {
            Chinese: "大会简介",
        },
    },
    {
        path: "/picture",
        name: "picture",
        component: () =>
            import(/* webpackChunkName: "head" */ "../views/forum/picture.vue"),
        meta: {
            Chinese: "精彩图片",
        },
    },
    {
        path: "/newVideo",
        name: "newVideo",
        component: () =>
            import(
                /* webpackChunkName: "head" */ "../views/forum/newVideo.vue"
            ),
        meta: {
            Chinese: "精彩图片",
        },
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    console.log(to, from);
    if ("download" == to.name) {
        // console.log('11');
        // store.state.activeIndex = 10
        // store.state.actives = null
        store.commit("SETACTIVE", 10);
        store.commit("SETACTIVES", null);
    } else if ("introduction" == to.name) {
        store.commit("SETACTIVE", -1);
        store.commit("SETACTIVES", 0);
    } else {
        // store.state.activeIndex = -1
        // store.state.actives = null
        store.commit("SETACTIVE", -1);
        store.commit("SETACTIVES", null);
    }

    next();
});
export default router;
